const apiUrl = process.env.REACT_APP_API_URL;

export const apiMobiChef = async (url: string, data: any, showError: (message: string) => void) => {
    const requestData = data ? JSON.stringify(data) : JSON.stringify({});
    try {
        const response: any = await fetch(`${apiUrl}${url}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: requestData,
        });
        const dataResponse = await response.json();
        return (dataResponse)
    } catch (error: any) {
        showError(error.message);
    }
};
